import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import ReactYT from '../../../Core/ReactYT';

export const Wrapper = styled.div`
  position: relative;

  height: 310px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    height: 510px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    height: 710px;
  }
`;

export const TitleWrapper = styled.div`
  position: absolute;
  padding: 0 30px;

  margin: 20px auto 0;
  max-width: 465px;

  h1 {
    color: ${({ focusTextColour }) => focusTextColour || themeGet('colors.white')};
  }

  h2,
  h3,
  h4,
  h5,
  p {
    font-weight: bold;
    font-size: 20px;
    letter-spacing: 0;
    line-height: 28px;
    text-align: center;
    color: ${({ focusTextColour }) => focusTextColour || themeGet('colors.white')};
    margin-bottom: 15px;
  }

  h2:last-child,
  h3:last-child,
  h4:last-child,
  h5:last-child,
  p:last-child {
    color: ${({ focusTextColour }) => focusTextColour || themeGet('colors.text-primary')};
    text-align: center;
    font-size: 24px;
    letter-spacing: -0.53px;
    line-height: 28px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 46px auto 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 146px auto 0;
    max-width: 981px;

    h2,
    h3,
    h4,
    h5,
    p {
      font-size: 26px;
      font-weight: bold;
      letter-spacing: -0.5px;
      line-height: 38px;
    }

    h2:last-child,
    h3:last-child,
    h4:last-child,
    h5:last-child,
    p:last-child {
      font-size: 38px;
      letter-spacing: -0.53px;
      line-height: 46px;
    }
  }
`;

export const StyledVideo = styled(ReactYT)`
  display: ${({ playing }) => (playing ? 'block' : 'none')};
  height: 310px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    height: 510px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    height: 710px;
  }
`;
